module.exports = __webpack_public_path__ + "static/media/product-bg-2.882eed06.png";